import { Modal } from "react-bootstrap";
import classes from "./PushToCmsModal.module.css";
import React from "react";
import { LoaderIcon } from "react-hot-toast";
import { ThreeDots } from "react-loader-spinner";
import classNames from "classnames";
import { usePushToCmsModal } from "./usePushToCmsModal";

const TABLE_HEADINGS = [
  "",
  "Product Name",
  "Image Count",
  "SKU/Store Product Id",
  "Body Type",
  "Gender",
  "Variants",
];

const PushToCmsModal = ({
  openSandboxPush,
  setOpenSandboxPush,
  summaryLoader,
  openSandboxMessage,
  pushSummary,
  pushLoader,
  handlePush,
  fetchProducts,
  setOpenSandboxMessage,
  sandBoxStatus,
  rejectedProducts,
  openRows,
  toggleRow,
}) => {
  const {
    handleProductCheckboxChange,
    handleVariantCheckboxChange,
    isProductChecked,
    isVariantChecked,
    selectedProductsToPush,
  } = usePushToCmsModal();
  return (
    <Modal
      show={openSandboxPush}
      onHide={() => setOpenSandboxPush(false)}
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="max-w-[70vw]"
      size="lg"
      centered
    >
      <Modal.Header closeButton>Push to CMS</Modal.Header>
      <Modal.Body>
        <div className="col-md-12">
          {!summaryLoader ? (
            <>
              {!openSandboxMessage ? (
                <div className="space-y-4">
                  <div className={classes.infoMessage}>
                    <p>These products are ready to be pushed to the CMS.</p>
                  </div>

                  <div className="h-[60vh] overflow-x-auto">
                    <table className="w-full border-collapse">
                      <thead>
                        <tr className="bg-gray-200 text-left">
                          {TABLE_HEADINGS.map((heading, index) => (
                            <th
                              key={index}
                              className={classNames("p-2", {
                                "w-[46px]": index === 0,
                              })}
                            >
                              {heading}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {pushSummary.length > 0 ? (
                          <>
                            {pushSummary.map((product) => (
                              <React.Fragment key={product.iTempId}>
                                <tr className="border-b">
                                  <td className="p-2">
                                    <input
                                      name="productCheckbox"
                                      type="checkbox"
                                      className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                      onChange={(e) =>
                                        handleProductCheckboxChange(
                                          product,
                                          e.target.checked
                                        )
                                      }
                                      checked={isProductChecked(
                                        product.iProductId
                                      )}
                                    />
                                  </td>
                                  {console.log(
                                    "product.aVariants",
                                    product.aVariants
                                  )}
                                  <td className="p-2">
                                    {product.sProductName || "-"}
                                  </td>
                                  <td className="p-2">
                                    {product.iProductImageCount || "-"}
                                  </td>
                                  <td className="p-2">{product.sSKU || "-"}</td>
                                  <td className="p-2">
                                    {product.sBodyType || "-"}
                                  </td>
                                  <td className="p-2">
                                    {product.sGender || "-"}
                                  </td>
                                  {console.log(product)}
                                  <td className="p-2">
                                    {product.aVariants ? (
                                      <button
                                        onClick={() =>
                                          toggleRow(product.iProductId)
                                        }
                                        className="text-blue-500 hover:underline outline-none focus:outline-none"
                                      >
                                        {openRows.includes(product.iProductId)
                                          ? "Hide Variants"
                                          : "Show Variants"}
                                      </button>
                                    ) : (
                                      "No Variants"
                                    )}
                                  </td>
                                </tr>

                                {openRows.includes(product.iProductId) &&
                                  product.aVariants &&
                                  JSON.parse(product.aVariants).map(
                                    (variant, idx) => (
                                      <tr key={idx} className="bg-gray-100">
                                        <td
                                          colSpan={TABLE_HEADINGS.length}
                                          className="py-2 pr-2 pl-5 text-sm text-gray-700"
                                        >
                                          <span className="flex items-center gap-2">
                                            <span className="flex items-center">
                                              <input
                                                type="checkbox"
                                                name="variantCheckbox"
                                                className="w-3.5 h-3.5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                onChange={(e) =>
                                                  handleVariantCheckboxChange(
                                                    variant.iVariantId,
                                                    product.iProductId,
                                                    e.target.checked
                                                  )
                                                }
                                                checked={isVariantChecked(
                                                  product.iProductId,
                                                  variant.iVariantId
                                                )}
                                              />
                                            </span>
                                            <span>
                                              <span className="font-semibold">
                                                SKU/Store Variant Id:
                                              </span>{" "}
                                              {variant.sSKU}
                                            </span>
                                            |
                                            <span>
                                              <span className="font-semibold">
                                                {" "}
                                                Title:
                                              </span>{" "}
                                              {variant.sVariantName}
                                            </span>
                                            |
                                            <span>
                                              <span className="font-semibold">
                                                Image Count:
                                              </span>
                                              {variant.iImageCount}
                                            </span>
                                          </span>
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </React.Fragment>
                            ))}
                          </>
                        ) : (
                          <tr className="border-b text-center">
                            <td className="p-2" colSpan={TABLE_HEADINGS.length}>
                              No Products Found!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="flex justify-center mt-3">
                    {pushLoader ? (
                      <button
                        className="bg-gray-400 text-white font-semibold px-4 py-2 rounded w-[100px] flex items-center justify-center"
                        disabled
                      >
                        <LoaderIcon size={20} className="animate-spin" />
                      </button>
                    ) : (
                      <button
                        className="bg-blue-500 text-white text-md font-semibold px-4 py-2 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
                        onClick={() => handlePush(selectedProductsToPush)}
                      >
                        Push Products
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <>
                  {rejectedProducts?.length > 0 ? (
                    <div className="p-6">
                      <div className="mb-2 text-gray-700">
                        Validation has failed for the following products. Please
                        review them and push the corrected products again.
                      </div>
                      <div className="rounded-lg bg-white shadow-md">
                        <h5 className="font-bold mb-2 text-gray-800">
                          Rejected Products
                        </h5>
                        <div className="overflow-x-auto">
                          <table className="min-w-full table-auto bg-white border border-gray-300 rounded-lg">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="px-4 py-2 border">SKU</th>
                                <th className="px-4 py-2 border">
                                  Validation Errors
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {rejectedProducts.map((row, idx) => (
                                <tr
                                  key={idx}
                                  className="bg-white hover:bg-gray-100"
                                >
                                  <td className="px-4 py-2 border">
                                    {row.sSKU}
                                  </td>
                                  <td className="px-4 py-2 border">
                                    {row.errors.join(", ")}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="mt-4">
                        <button
                          className="bg-blue-500 text-white font-semibold px-4 py-2 rounded-lg focus:outline-none"
                          onClick={() => {
                            fetchProducts();
                            setOpenSandboxMessage(false);
                            setOpenSandboxPush(false);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="p-6">
                      <span>{sandBoxStatus}</span>
                      <div className="mt-4">
                        <button
                          className="bg-blue-500 text-white font-semibold px-4 py-2 rounded-lg focus:outline-none"
                          onClick={() => {
                            fetchProducts();
                            setOpenSandboxMessage(false);
                            setOpenSandboxPush(false);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <div className="flex items-center justify-center">
              <ThreeDots
                height="100"
                width="100"
                color="#424858"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                outerCircleColor=""
                innerCircleColor=""
                barColor=""
                ariaLabel="circles-with-bar-loading"
              />
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PushToCmsModal;
